<template>
  <div class="Registration">
    <RegistrableConference
      v-if="Handover == 1"
      v-bind="$attrs"
      @upImmediatelyference="Handover = 3"
    />
    <RegisteredPersonnel
      v-if="Handover == 2"
      @AddPersonnel="Handover = 3"
      @ModifyTheForm="Handover = 1"
    />
    <TheRegistrationForm
      v-if="Handover == 3"
      @meetingSubmit="Handover = 2"
    />
  </div>
</template>
<script>
import TheRegistrationForm from "@/views/PCView/details/meetingDetails/components/meetingRegistration/TheRegistrationForm.vue";
import RegisteredPersonnel from "@/views/PCView/details/meetingDetails/components/meetingRegistration/RegisteredPersonnel.vue";
import RegistrableConference from "@/views/PCView/details/meetingDetails/components/meetingRegistration/RegistrableConference.vue";
export default {
  name: "Registration",
  components: {
    TheRegistrationForm,
    RegisteredPersonnel,
    RegistrableConference,
  },
  props: {},
  data() {
    return {
      Handover: 2, // 1可参会议 2参会人员表格 3添加参会人员表单
    };
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.Registration {
  width: 100%;
  margin-top: 50px;
  .not-enroll {
    margin-bottom: 20px;
    position: relative;
    .each {
      width: 100%;
      height: 90px;
      padding: 0 20px;
      background: #e0ebff;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      .left {
        margin-top: 15px;
        line-height: 30px;
        .h {
          font-size: 16px;
          color: #0344a1;
        }
        .time {
          font-size: 12px;
          color: #333333;
        }
        .money {
          display: inline;
          vertical-align: top;
          position: relative;
          left: 400px;
          top: -45px;
          .num {
            width: 100px;
            font-size: 18px;
            position: relative;
            top: 2px;
          }
        }
      }
      .right {
        line-height: 90px;
        .but {
          display: inline-block;
          width: 110px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          margin-top: 25px;
          background: #4585f5;
          border-radius: 5px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .shadow {
      width: 100%;
      height: 90px;
      display: flex;
      justify-content: center;
      position: absolute;
      top: 0px;
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.459);
      color: #fff;
      line-height: 90px;
      .begin {
        margin-right: 20px;
      }
      .enter {
        width: 110px;
        height: 40px;
        margin-top: 25px;
        background: #4585f5;
        line-height: 40px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>
